import { render, staticRenderFns } from "./ItemMultiselect.vue?vue&type=template&id=5a792f36&scoped=true&"
import script from "./ItemMultiselect.vue?vue&type=script&lang=js&"
export * from "./ItemMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./ItemMultiselect.vue?vue&type=style&index=0&id=5a792f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a792f36",
  null
  
)

export default component.exports